export default __webpack_public_path__ + "static/media/Share.02c98219.svg";